module.exports = __webpack_public_path__ + "static/img/industry3.8a6f017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry3.png
// module id = A3xI
// module chunks = 2